import { Outlet } from "react-router";

export default function ContextLayout() {
    return (
        <Outlet />
    )
}